// get User Associated Medias Map
export function getUserAssociatedMediasMap(mediaList = []) {
  const userAssociatedMediaListMap = {};

  mediaList.forEach((media) => {
    const { userId } = media;

    // ignore media which doesn't have userId
    if (!userId) {
      return;
    }

    if (!userAssociatedMediaListMap[userId]) {
      userAssociatedMediaListMap[userId] = [media];
    } else {
      userAssociatedMediaListMap[userId].push(media);
    }
  });

  return userAssociatedMediaListMap;
}

// get Medias Unique Stretch Count
export function getMediasUniqueStretchCount(mediaList = []) {
  const stretchIdsList = [];
  const stretchNameList = [];

  mediaList.forEach((media) => {
    const { roadStretchId, roadStretchName } = media;

    // if already exist in list
    if (stretchIdsList.includes(roadStretchId)) {
      return;
    }

    // append the data
    stretchIdsList.push(roadStretchId);
    stretchNameList.push(roadStretchName);
  });

  // count
  const stretchCount = stretchIdsList.length;

  return {
    stretchIdsList,
    stretchNameList,
    stretchCount,
  };
}
